import { intlService } from '~/i18n/IntlService';
import { publicApi } from '~/services/serviceInstances';

interface Request {
  id: string;
}

export const getExternalDocument = async ({ id }: Request): Promise<File> => {
  try {
    return await publicApi.post(
      `contracts/documents/presigned-documents`,
      { id },
      { responseType: 'blob' },
    );
  } catch {
    throw new Error(
      intlService.getIntl().formatMessage({
        id: 'getExternalDocument.documentNotFound',
        defaultMessage: 'Document not found',
        description: 'Error message when external document is not found',
      }),
    );
  }
};
